const constants = {
  add: 'add',
  newGroup: '+ New group',
  addLaterId: 'addLater',
  addLaterName: 'Add to group later',
};

export default constants;
